import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'svgIconNameInNamespaceByUrl', standalone: true })
export class SvgIconNameInNamespaceByUrlPipe implements PipeTransform {
  transform(url: string, namespace?: string): string {
    const svgIconName = url.match(/\/([^/]+)\.svg$/)[1];

    return namespace ? `${namespace}:${svgIconName}` : svgIconName;
  }
}
